import { render, staticRenderFns } from "./MessageTranslateDialog.vue?vue&type=template&id=0b892b76&scoped=true"
import script from "./MessageTranslateDialog.vue?vue&type=script&lang=js"
export * from "./MessageTranslateDialog.vue?vue&type=script&lang=js"
import style0 from "./MessageTranslateDialog.vue?vue&type=style&index=0&id=0b892b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b892b76",
  null
  
)

export default component.exports